export default "__VITE_ASSET__a725e07f__"